import api from '../../store/config/api';
import { TASK_LIST as SCHEMA } from '../../schemas';
import { format } from '../../util/url';

export const [
  GET_TASKS,
  GET_TASKS_REQUEST,
  GET_TASKS_SUCCESS,
  GET_TASKS_FAILURE
] = api.buildTypes('GET_TASKS');

export function getTasks(options) {
  const {
    teamName,
    username,
    assignedTo,
    status,
    limit,
    pageKey,
    q,
    sort
  } = options;

  if (!q) {
    const query = {};
    if (assignedTo) {
      query.assignedTo = Array.isArray(assignedTo)
        ? assignedTo.join(',')
        : assignedTo;
    }
    if (status) {
      query.status = status;
    }
    if (limit) {
      query.limit = limit;
    }
    if (pageKey) {
      query.after = pageKey;
    }
    if (sort) {
      query.sort = sort;
    }

    return {
      type: GET_TASKS,
      payload: {
        url: format({
          pathname: `/teams/${teamName}/tasks`,
          query
        }),
        schema: SCHEMA,
        options: {
          method: 'GET'
        }
      }
    };
  }

  const query = {
    types: 'tasks'
  };
  if (status && status !== 'all') {
    query.status = status;
  }
  if (username) {
    query.assignedTo = Array.isArray(username) ? username.join(',') : username;
  }
  if (limit) {
    query.limit = limit;
  }
  if (pageKey) {
    query.pageToken = pageKey;
  }
  if (q) {
    query.q = q;
  }
  if (sort) {
    query.sort = sort;
  }

  const url = format({
    pathname: `/teams/${teamName}/search`,
    query
  });

  return {
    type: GET_TASKS,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  GET_USER_TASKS,
  GET_USER_TASKS_REQUEST,
  GET_USER_TASKS_SUCCESS,
  GET_USER_TASKS_FAILURE
] = api.buildTypes('GET_USER_TASKS');

export function getUserTasks({ teamName, username = 'me', status = 'all' }) {
  return {
    type: GET_USER_TASKS,
    payload: {
      url: `/teams/${teamName}/users/${username}/tasks?status=${status}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  UPDATE_TASKS,
  UPDATE_TASKS_REQUEST,
  UPDATE_TASKS_SUCCESS,
  UPDATE_TASKS_FAILURE
] = api.buildTypes('UPDATE_TASKS');

export function updateTasks({ teamName, runID, tasks }) {
  return {
    type: UPDATE_TASKS,
    payload: {
      url: `/teams/${teamName}/runs/${runID}/tasks`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: tasks
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/tasks.js